import { render, staticRenderFns } from "./EstoqueEditar.vue?vue&type=template&id=6f0165c1&"
import script from "./EstoqueEditar.vue?vue&type=script&lang=js&"
export * from "./EstoqueEditar.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueEditar.vue?vue&type=style&index=0&id=6f0165c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports